const et = {
  idCardReadTimeout: 'ID kaardi lugemine võttis liiga kaua aega. Palun sulge kõik brauseri aknad ja proovi uuesti.',
};

export default et;
